import { stripTrailingSlash } from './normalizePathname';

const ensureTrailingSlash = url => `${stripTrailingSlash(url)}/`;

export default ensureTrailingSlash;
